import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { debounce } from 'lodash';

export default function staggeredSlideUp(
    el: Element,
    containerEl: HTMLElement | null,
    isMarkersEnabled: boolean
): void {
    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = containerEl || el;

    const scrollTriggerOptions = {
        trigger: triggerEl,
        scrub: 1,
        start: 'clamp(top 100%)',
        end: 'clamp(60% 80%)',
        markers: isMarkersEnabled,
        toggleActions: 'restart none none none',
    };

    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: no-preference)', () => {
        const tl = gsap.timeline();
        tl.from(triggerEl, { autoAlpha: 0 }).from(el.children, {
            y: 150,
            opacity: 0.5,
            stagger: 0.1,
            duration: 0.5,
            scrollTrigger: scrollTriggerOptions,
        });
    });
    mm.add('(prefers-reduced-motion: reduce)', () => {
        const tl = gsap.timeline();
        tl.from(triggerEl, { autoAlpha: 0 });
    });

    // Add MutationObserver to refresh ScrollTrigger on DOM changes anywhere in the body
    // This helps make sure that the triggers are not misaligned when content is dynamically added or removed
    if ('MutationObserver' in window) {
        const debounceRefresh = debounce(() => {
            ScrollTrigger.refresh();
        }, 1000);

        let lastBodyHeight = document.body.offsetHeight;

        const mutationObserver = new MutationObserver(mutationsList => {
            // DOM changes are actually fairly frequent, so we only care about it if the body height changes
            const currentBodyHeight = document.body.offsetHeight;
            if (currentBodyHeight !== lastBodyHeight) {
                lastBodyHeight = currentBodyHeight;
                debounceRefresh();
            }
        });

        mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
}
